import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';
import { Button } from './ui/button';

const COOKIE_KEY = 'cookie_consent';
const COOKIE_EXPIRY_DAYS = 365;

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Hide banner on admin pages
    if (typeof window !== 'undefined' && (window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/dashboard-resto') || window.location.pathname.startsWith('/cuisine'))) {
      return;
    }
    const stored = localStorage.getItem(COOKIE_KEY);
    if (!stored) {
      // Small delay so it doesn't flash immediately on page load
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
    try {
      const { expires } = JSON.parse(stored);
      if (expires && new Date(expires) < new Date()) {
        localStorage.removeItem(COOKIE_KEY);
        setVisible(true);
      }
    } catch {
      // Corrupted value — show banner again
      setVisible(true);
    }
  }, []);

  const saveChoice = (choice) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_EXPIRY_DAYS);
    localStorage.setItem(
      COOKIE_KEY,
      JSON.stringify({ choice, expires: expires.toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] animate-in fade-in slide-in-from-bottom-4 duration-500"
      data-testid="cookie-banner"
    >
      <div className="bg-[#1C1917] text-white rounded-2xl shadow-2xl p-5 md:p-6 relative">
        <button
          onClick={() => saveChoice('dismissed')}
          className="absolute top-3 right-3 text-stone-400 hover:text-white transition-colors"
          aria-label="Fermer"
          data-testid="cookie-banner-close"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-[#C62E2E]/20 flex items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-[#C62E2E]" />
          </div>
          <div className="flex-1">
            <h3 className="font-['Playfair_Display'] text-lg font-semibold mb-1">
              Cookies & vie privée
            </h3>
            <p className="text-stone-300 text-sm leading-relaxed">
              Nous utilisons uniquement des cookies <strong>strictement nécessaires</strong> au
              fonctionnement du site (session admin, sécurité paiement). Aucun cookie publicitaire ni
              traceur tiers.
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 mt-4">
          <Button
            onClick={() => saveChoice('accepted')}
            className="flex-1 bg-[#C62E2E] hover:bg-[#a02424] text-white rounded-full"
            data-testid="cookie-banner-accept"
          >
            J'ai compris
          </Button>
          <Link
            to="/politique-cookies"
            className="flex-1 inline-flex items-center justify-center border border-white/20 hover:bg-white/10 text-white rounded-full px-4 py-2 text-sm transition-colors"
            data-testid="cookie-banner-learn-more"
          >
            En savoir plus
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
